/* eslint-disable react/require-default-props */
import { memo } from "react";
import Button from "@mui/material/Button";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import { useNavigate } from "react-router-dom";
import CustomBoxModal from "../CustomModalBox";

interface Props {
  shortMessage: string;
  longMessage: string;
  isButtonEnable?: boolean;
}
function OTPSucess({ shortMessage, longMessage, isButtonEnable = true }: Props) {
  const navigate = useNavigate();
  return (
    <CustomBoxModal>
      <CheckCircleOutlineRoundedIcon
        className="!text-earlySpring !h-31.75 !w-31.75 !stroke-none mt-8 rounded-full"
        fontSize="small"
      />

      <h3 className="text-center font-montserrat text-1.5xl font-bold leading-normal mt-8 h-6.75 ml-34.5 mr-34.5 whitespace-nowrap">
        {shortMessage}
      </h3>

      <p className="mx-auto mt-4 h-5 pb-10 text-black font-Montserrat text-sm font-medium leading-5 whitespace-nowrap">
        {longMessage}
      </p>

      {isButtonEnable && (
        <div className="mb-4">
          <Button
            variant="contained"
            onClick={() => {
              navigate("/dashboard");
            }}
            className="!uppercase h-13 w-53.25 rounded-lg"
          >
            Go To Dashboard
          </Button>
        </div>
      )}
    </CustomBoxModal>
  );
}

export default memo(OTPSucess);
